import { Config } from "../../../configurations/config";

export const myOfficeHoursAPIs = {
    GetWeeklyAndMonthlyHours:`${Config.server_url}${Config.api_prefix}/Dashboard/GetWeeklyAndMonthlyHours`,
    GetTotalHoursAPI:`${Config.server_url}${Config.api_prefix}/MyOfficeHours/GetTotalHours`,
    GetExportToExcelAPI:`${Config.server_url}${Config.api_prefix}/EmployeeAttendance/Attendance/ExportToExcel`,
    GetMyOfficeHoursAPI:`${Config.server_url}${Config.api_prefix}/MyOfficeHours`,
    GetUpdateCheckOutTimeAPI:`${Config.server_url}${Config.api_prefix}/MyOfficeHours/UpdateCheckOutTime`,
    GetOfficeHoursStatus:`${Config.server_url}${Config.api_prefix}/MyOfficeHours/GetStatusTypes`,
    GetSupervisorEmployees_API: `${Config.server_url}${Config.api_prefix}/Employee/GetAllEmployees`,
    GetEmployeesAttendance_API: `${Config.server_url}${Config.api_prefix}/EmployeeAttendance/Attendance`,

}